export default "__VITE_ASSET__875de9cc__"